import { render, staticRenderFns } from "./detailDrLeftbanner.vue?vue&type=template&id=07fa870c&scoped=true"
import script from "./detailDrLeftbanner.vue?vue&type=script&lang=js"
export * from "./detailDrLeftbanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa870c",
  null
  
)

export default component.exports